import React from 'react';
import dayjs from 'dayjs';
import classes from './ExpenseMobileCard.module.scss';
import { generalEnums } from '../../../../../utils/enums';

export default function ExpenseMobileCard(props) {
  const { info } = props;

  return (
    <div className={classes.container}>
      <div className={classes.column}>
        <p className={classes.comment}>{dayjs(info.CreatedDate).format(generalEnums.DATEWITH_MMM)}</p>
        <p className={classes.date}>{`${info?.User?.FirstName} ${info?.User?.LastName}`}</p>
      </div>
      <div className={classes.column}>
        <p className={classes.amount}>
          {info.ExpenseCurrency?.Symbol} {info.TotalExpense}
        </p>
      </div>
    </div>
  );
}
